import { buildModelManager } from "../builder.js";
const DefaultKnowledgeBaseSelection = {
  __typename: true,
  id: true,
  agentTypes: true,
  category: true,
  content: { markdown: true, truncatedHTML: true },
  createdAt: true,
  createdById: true,
  embedding: true,
  extractedText: { markdown: true, truncatedHTML: true },
  fileProcessingStatus: true,
  institution: true,
  isActive: true,
  lastModifiedById: true,
  priority: true,
  processingError: true,
  source: true,
  tags: true,
  title: true,
  updatedAt: true,
  uploadedFile: { url: true, mimeType: true, fileName: true }
};
const modelApiIdentifier = "knowledgeBase";
const pluralModelApiIdentifier = "knowledgeBases";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultKnowledgeBaseSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createKnowledgeBase",
    operationReturnType: "CreateKnowledgeBase",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      knowledgeBase: { required: false, type: "CreateKnowledgeBaseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultKnowledgeBaseSelection
  },
  {
    type: "action",
    operationName: "bulkCreateKnowledgeBases",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateKnowledgeBasesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultKnowledgeBaseSelection
  },
  {
    type: "action",
    operationName: "updateKnowledgeBase",
    operationReturnType: "UpdateKnowledgeBase",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      knowledgeBase: { required: false, type: "UpdateKnowledgeBaseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultKnowledgeBaseSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateKnowledgeBases",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateKnowledgeBasesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultKnowledgeBaseSelection
  },
  {
    type: "action",
    operationName: "deleteKnowledgeBase",
    operationReturnType: "DeleteKnowledgeBase",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteKnowledgeBases",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertKnowledgeBase",
    operationReturnType: "UpsertKnowledgeBase",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      knowledgeBase: { required: false, type: "UpsertKnowledgeBaseInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateKnowledgeBaseResult": { hasReturnType: false },
      "... on UpdateKnowledgeBaseResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultKnowledgeBaseSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertKnowledgeBases",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertKnowledgeBasesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultKnowledgeBaseSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "knowledgeBaseGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const KnowledgeBaseManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultKnowledgeBaseSelection,
  operations
);
export {
  DefaultKnowledgeBaseSelection,
  KnowledgeBaseManager
};
//# sourceMappingURL=KnowledgeBase.js.map
